module.exports = __webpack_public_path__ + "img/Weapon_60.7ffc477c.png";